import { Box, FormControl, MenuItem, Select, TextField, Typography } from '@mui/material';
import { dropDownStyles } from './DropDownComponent';
import InputField from '../Calculations/Conditions/Evaluation/InputField';
import { useEffect, useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { fontSize, palette } from '../..';
import { TopNOperators } from './FilterPatternCollection';
import { useDispatch } from 'react-redux';
import { updateAxesQueryParam } from '../../redux/ChartPoperties/ChartPropertiesActions';
import { callQueryAPI, SetModifyOptions } from '../../redux/ChartPoperties/ChartControlsActions';
interface TopnProps {
  propKey: string;
  axisName: string;
  filterFieldData: any;
  color?: string;
  itemIndex: number;
}
function TopN({ filterFieldData, color, propKey, axisName, itemIndex }: TopnProps) {
  const [value, setValue] = useState(filterFieldData?.exprInput);
  useEffect(() => setValue(filterFieldData?.exprInput), [filterFieldData]);
  const dispatch = useDispatch();
  const handleValueChange = (type: 'operator' | 'value', value: string) => {
    const updated = {
      ...filterFieldData,
      [type === 'operator' ? 'exprType' : 'exprInput']: value,
    };
    let isSame = false;
    if (type === 'value') filterFieldData.exprInput == value ? (isSame = true) : (isSame = false);
    dispatch(updateAxesQueryParam(propKey, 0, itemIndex, updated, axisName));
    dispatch(SetModifyOptions(propKey, 'filter', filterFieldData.uId));
    if (!filterFieldData.uID && !isSame) dispatch(callQueryAPI(propKey, true));
  };
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
      }}
    >
      <FormControl
        fullWidth
        size="small"
        variant="outlined"
        sx={{
          ...dropDownStyles.customSelect,
          width: '100%',
          '& .MuiOutlinedInput-root': {
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: color,
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: color,
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: color,
            },
          },
        }}
      >
        <Select
          sx={{
            height: '1.5rem',
            fontSize: fontSize.large,
            textAlign: 'left',
            color: color || palette.primary.contrastText,
            right: '1px',
            '.MuiSelect-icon': {
              right: '1px',
            },
          }}
          IconComponent={KeyboardArrowDownIcon}
          onChange={(e) => {
            handleValueChange('operator', e.target.value);
          }}
          value={filterFieldData.exprType}
          renderValue={(selectedValue) => {
            const selectedItem = TopNOperators.find((item) => item.key === selectedValue);
            return (
              <Typography sx={{ color: color, fontSize: '12px' }}>
                {selectedItem ? selectedItem.value : ''}
              </Typography>
            );
          }}
        >
          {TopNOperators.map((item: any) => {
            return (
              <MenuItem
                key={item.key}
                value={item.key}
                sx={{
                  '&.Mui-selected': {
                    backgroundColor: 'rgba(43, 185, 187, 0.1)', // Change background color for selected option
                  },
                  '&.Mui-selected:hover': {
                    backgroundColor: 'rgba(43, 185, 187, 0.2)', // Change hover background color
                  },
                }}
              >
                <Typography
                  sx={{
                    minWidth: '100%',
                    width: 'auto',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontSize: '12px',
                    lineHeight: '20px',
                  }}
                >
                  {item.value}
                </Typography>
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      <Box
        sx={{
          height: '1.5rem',
          padding: '0.3rem',
          border: `1px solid  #d3d3d3`,
          display: filterFieldData.isParameterized ? 'none' : 'flex',
          alignItems: 'center',
          borderRadius: '5px',
        }}
      >
        <InputField
          type="number"
          value={value ?? ''}
          disabled={false}
          onBlur={(value) => handleValueChange('value', value)}
          applyExcludeStyle={filterFieldData?.includeexclude === 'Exclude'}
        />
      </Box>
    </Box>
  );
}

export default TopN;
